import { PaperclipIcon } from 'lucide-react'
import type { FC, ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

interface ChatInputAttachButtonDisabledProps {
  reason: string
  className?: string
}

/**
 * Disabled attach button with a tooltip explaining why attachments are unavailable.
 */
export const ChatInputAttachButtonDisabled: FC<ChatInputAttachButtonDisabledProps> = ({
  reason,
  className,
}): ReactNode => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span className="inline-flex">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          disabled
          className={cn('chat-input-attach-button gap-1.5', className)}
          aria-label={reason}
        >
          <PaperclipIcon className="size-4" />
          <span className="hidden sm:inline">Attach</span>
        </Button>
      </span>
    </TooltipTrigger>
    <TooltipContent side="top">{reason}</TooltipContent>
  </Tooltip>
)

ChatInputAttachButtonDisabled.displayName = 'ChatInputAttachButtonDisabled'
